import React, { Component }  from "react";
import ReactDOM from "react-dom";
import isEmpty from "lodash/isEmpty";
import moment from 'moment'; 
import Board from "react-trello";
//import styled from 'styled-components'
//import {LoadingSpinner} from 'components';
//import "./styles.css";
//import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import MultiSelect from "react-multi-select-component";
//import Spinner from 'react-bootstrap/Spinner'
import ReactSpinner from 'react-bootstrap-spinner'

import "./style.css";

import logo from './35.gif';

/*
const options = [
  { label: 'Thing 1', value: 1},
  { label: 'Thing 2', value: 2},
];*/
//const [count, setCount] = useState(0);

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

class ProductList extends React.Component{ 

   constructor(props){
            super(props);
            this.myRef = React.createRef();
        this.state = { 
            count: 1,
            loading:1,
            info:'',
             key:'',
            showdiv: true,
             selected: [],
            boardData:[{label: '', value: '',isChecked: false}],
            fields: {tagname:'',cname:'',prjname:''},
            errors: {cname:"",products:""},
            laneData:{},
            reorderedlane:{}
            
            }
            this.baseState = this.state;
       // this.onDragEnd = this.onDragEnd.bind(this);
          this.handleChange = this.handleChange.bind(this);
          this.handleSubmit=this.handleSubmit.bind(this);
          this.handleValidation=this.handleValidation.bind(this);
          this.countUp = this.countUp.bind(this);
          this.countDown = this.countDown.bind(this);
          this.onDragEnd = this.onDragEnd.bind(this);
          this.DataChange = this.DataChange.bind(this);
          this.baseboard = this.baseboard.bind(this);

   }


   componentWillMount() {
        this.getProductData();

           const data = {
          lanes: [
            {
              id: "Products",
              title: "Products",
              //style: { width: 280 },
              cards: []
            },
            /*
            {
              id: "Required List",
              title: "Required List",
              
              cards: []
            }*/
          ]
        };
        //console.log(data);
                this.setState({laneData:data });


        }
   
baseboard=()=>{
  
    const bdata = {
          lanes: [
            {
              id: "Products",
              title: "Products",
              //style: { width: 280 },
              cards: []
            },
            /*
            {
              id: "Required List",
              title: "Required List",
              
              cards: []
            }*/
          ]
        };
          this.setState({laneData:bdata });
}

componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state,callback)=>{
        return;
    };
}

onDragEnd(result,sourceLaneId, targetLaneId, position, cardDetails) {
//console.log(result+"  "+position);




/*
const items = reorder(
      this.state.laneData,
      result.source.index,
      result.destination.index
    );*/

//console.log(cardDetails);


}

LaneUpdate(laneId, data){
  //console.log("LaneUpdate");
  //console.log(data);
}
DataChange(newData){
  //console.log("Data change");
  /*console.log(newData);
  console.log(newData.lanes[0].cards);*/

  this.setState({reorderedlane:newData.lanes[0].cards});
//console.log(this.state.reorderedlane);
}

countUp=()=> {
    this.setState(currentState => {
      return { count: currentState.count + 1 };
    });
  }
  countDown=()=> {
    this.setState(currentState => {
      return { count: currentState.count - 1 };
    });
  }

  updateboard=(sel)=>{


    const data = {
          lanes: [
            {
              id: "Products",
              title: "CustProducts",
              //style: { width: 280 },
              cards: sel.map(user => ({
                id: user.value,
                title: user.label,
                description: user.label
              }))
            },
            /*
            {
              id: "Required List",
              title: "Required List",
              
              cards: []
            }*/
          ]
        };
        //console.log(data);
                //this.setState({selected}),
                this.setState({selected:sel,laneData:data });

  }

        getProductData = (pro) => {
              //console.log("get data calling="+new Date().toLocaleString());
               this.api=window.$apibase+"/api/prodtlistboard";
              let cards={};
                //fetch("https://jsonplaceholder.typicode.com/users")
                fetch(this.api)
                  .then(response => response.json())
                  .then(res => {
                    //console.log(res);
                 //let values = [...this.state.boardData];
                /*res.map((user,index) => {
               
                  values.push(user);
                
              })*/
              this.setState({
      boardData: res.map((item, itemIndex) => {
       
             
             const list=item
           return list;  
       })
       });
             

                    
                  });
        }
/* https://www.skptricks.com/2018/06/simple-form-validation-in-reactjs-example.html */
 handleValidation(){
        let fields = this.state.fields;
        let err =this.state.errors;
        let formIsValid = true;
        //console.log("length="+this.state.selected.length);
           /*if(fields["cname"]=="")
           {
              formIsValid = false;
              err.cname = "Client Name Should not Be blank";
              //console.log( err["cname"]);
             
           } */       
           if (typeof fields["cname"] !== "undefined") {
              if (!fields["cname"].match(/^[a-zA-Z0-9@ ]*$/)) {
                formIsValid = false;
                err.cname = "*Please enter alphabet characters only.";
              }
           }
           if(this.state.selected.length===0)
           {
              formIsValid = false;
              err.products = "*Please Select the product.";
           }
            
            
          //  console.log( err);
            this.setState({errors:err});
            //console.log( this.state.errors.cname);
            //console.log( err["cname"] );
          return formIsValid;
        }
handleChange(field, e){

let name = e.target.name;
        let value = e.target.value;
       let errors = this.state.errors;

       switch (name) {
          case "cname":
          errors.cname=value.length < 5 ? 'Client Name must be at least 5 characters long!': '';
        break;
        default:
        break;

       }

           this.setState(prevState => {
                prevState.fields[name] =  value;
                return {
                        fields: prevState.fields
                        };
             });

            this.setState({errors, [name]: value});
} 
               handleSubmit = (e) => {
                e.preventDefault();
                e.persist();
                //document.getElementById( 'loader' ).style.display = 'block';
               //this.setState({ showdiv: false }); 
               //this.state.showdiv=false;
               //this.setState({showdiv : !this.state.showdiv});
               //this.setState({ loading: true });
               this.setState({ key: Math.random() });
               
            //  this.setState(function(prevState, props){
              //       return {loading: !prevState.loading}
               //   });
                    
                    //    console.log("show div"+this.state.showdiv);      
                     
                      if(this.handleValidation())
                      {
                             
                            const formData = new FormData(); 
                            formData.append("cname",this.state.fields.cname);
                            formData.append("projectname",this.state.fields.prjname);
                            formData.append("productset",this.state.fields.tagname);
                            //formData.append("products",JSON.stringify(this.state.selected)); 
                            formData.append("products",JSON.stringify(this.state.reorderedlane)); 
                                    /// enable loading process
                                //this.state.loading="11";
                            //console.log(this.state.loading);
                             //ReactDOM.findDOMNode(this.myRef.current).setAttribute('disabled', true);
                            if(this.state.selected.length>0)
                               this.state.errors.products="";

                            
                            this.forceUpdate();
                            this.setState(currentState => {
                            //console.log(currentState);
                                        // Important: read `state` instead of `this.state` when updating.
                          return {loading: currentState.loading+1,key: Math.random() }
                            }, () => {

                          /*     this.setState(function(prevState, props){
                                  return {loading: !prevState.loading}
                              }, () => {

                            this.setState({ loading: true }, () => {*/
                                this.countUp();
                                 //console.log(this.state.count);
                                 this.setState({info:"Processing..."});
                              //console.log("loading status="+this.state.loading);
                                  fetch(window.$apibase+'/api/client', {
                                method: 'POST',
                                body: formData,
                                    //headers: { 'Content-Type': 'application/json' },
                                    //body: JSON.stringify(this.state)
                                
                                /* https://medium.com/yellowcode/download-api-files-with-react-fetch-393e4dae0d9e */
                               }).then((response) => response.blob())
                                  .then((blob) => {
                                        let dt=moment().format('YYYYMMDDhhmms');
                                        let pdfname="DataSheet-"+dt+".pdf";
                                      const url = window.URL.createObjectURL(new Blob([blob]));
                                        const link = document.createElement('a');
                                        link.href = url;
                                        link.setAttribute('download', pdfname);
                                        // 3. Append to html page
                                        document.body.appendChild(link);
                                        // 4. Force download
                                        link.click();
                                        // 5. Clean up and remove the link
                                        link.parentNode.removeChild(link);

                                       // this.setState({fields.cname,""});
                                       // this.setState({ loading: "10" });     /// disbale loading process
                                        this.setState({selected:[],info:"Downloaded"});
                                       // ReactDOM.findDOMNode(this.myRef.current).setAttribute('disabled', false);

                                  });
                                    this.setState({ loading: 1 });
                                      //console.log("loading status="+this.state.loading);
                                      this.countDown();
                            });
                                
                                // document.getElementById( 'loader' ).style.display = 'none';
                             //this.setState(this.baseState);
                             //this.countDown();
                             this.state.fields.cname="";
                             this.state.fields.prjname="";
                             this.state.fields.tagname="";

                             
                             this.getProductData();
                             this.baseboard();
                             


                              
                      }
                      else
                      {
                              // alert("invalid Details");
                              return false;
                      }

                       /* this.setState(function(prevState, props){
                            return {loading: !prevState.loading}
                        });
                      this.setState({ loading: false });*/

                              this.setState({ key: Math.random() });
                              //console.log("loading stats="+this.state.loading);
                              
               
                }





    render(){
    const tempdata=this.state.boardData
    const {selected,loading} = this.state;
    //console.log(this.state.loading);
    //const smb=<button className="btn btn-primary mr-2" type="submit">Save and Generate PDF</button>
  return (
            <>
            <div className="col-md-12">
                <div className="form-row">  
                    <div className="col-md-6">
                    <form method="post" onSubmit={this.handleSubmit.bind(this)}>
                        <div className="form-row">
                            <div className="form-group col-sm-12">
                               <label htmlFor="cname">Client Name</label>
                               
    
                                <input  className="form-control" name="cname" id="cname_id"
                                 type="text" value={this.state.fields.cname}
                                    onChange={this.handleChange.bind(this, "cname")}
                                />
                                <span style={{color: "red"}}>{this.state.errors.cname}</span>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-sm-12">
                               <label htmlFor="prjname">Project Name</label>
                                <input  className="form-control" name="prjname" id="prname_id"
                                 type="text"  value={this.state.fields.prjname}
                                    onChange={this.handleChange.bind(this, "prjname")} 
                                />
                            </div>
                        </div>
                        <div id="loader" style={{display:"none"}}> <img src={logo} alt="logo"  /></div>
                        <div className="form-row">
                          <div className="form-group col-sm-12">
                             <label htmlFor="tagname">ProductSet Name</label>
                              <input ref="tagname" className="form-control" name="tagname" id="tagname_id"
                               type="text"  value={this.state.fields.tagname}
                                  onChange={this.handleChange.bind(this, "tagname")} 
                              />
                              
                          </div>
                        </div>
                        
                        <div>
        {  isEmpty(tempdata) 
          ? "<p>Loading</p>"
          :  <div className='form-group col-sm-12'> <label htmlFor='prdlist'>Product List<span style={{color: "red"}}>(*)</span></label><MultiSelect
        options={tempdata}
        value={selected}
        onChange={selected => this.updateboard(selected)}
        labelledBy={"Select"}
      />
      <span style={{color: "red"}}>{this.state.errors.products}</span>
      
      </div>
            }
            </div>
                      <span><h3>Status:{this.state.info}</h3></span>
                        { this.state.info==="Processing..."?<ReactSpinner type="border" color="primary" size="5" key={this.state.count} />:<button className="btn btn-primary mr-2" type="submit" onSubmit={this.handleSubmit.bind(this)} ref={this.myRef}>Save and Generate PDF</button>} 
                        
                        {/*{ loading ? <img src={logo} alt="logo"  key={this.state.key}/>  : <button className="btn btn-primary mr-2" type="submit" >Save and Generate PDF</button> } */}
                   </form>
                   </div>
                     <div className="col-md-6">
                     <h2 className="title">Product Set</h2>
                    <Board style={{backgroundColor: 'white'}} data={this.state.laneData} handleDragEnd={this.onDragEnd} onDataChange={this.DataChange} onLaneUpdate={this.LaneUpdate} draggable/>
                      </div>

           
              </div>
            </div>

    </>
    );
    }
}
export default ProductList;